import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import TableToolbar from '../../../../../components/stories/organisms/table/components/toolbar'
import ShowInactiveSwitch from '../../../../../components/show-inactive-switch'
import PlanMenuBulkContextMenu from '../../plan-menu-bulk-context-menu'

const PlanMenuTileToolbar = ({
  setSearch = () => {},
  search,
  setShowInactive = () => {},
  showInactive,
  hideToggle = false,
  selectedItems,
  setSelectedItems = () => {}
}) => {
  const { formatMessage } = useIntl()

  const clearRowSelection = () => {
    setSelectedItems([])
  }

  return (
    <TableToolbar.Root>
      <TableToolbar.LeftContainer>
        <TableToolbar.Search
          value={search}
          onChangeSearch={setSearch}
          defaultDesktopVariantOpen={!!search}
        />
        {!hideToggle && (
          <ShowInactiveSwitch
            checked={showInactive}
            onCheckedChange={setShowInactive}
            label={formatMessage({ id: 'plans_overview_show-inactive' })}
          />
        )}
      </TableToolbar.LeftContainer>
      <TableToolbar.RightContainer>
        <PlanMenuBulkContextMenu
          onBatchComplete={clearRowSelection}
          selectedItems={selectedItems}
        />
      </TableToolbar.RightContainer>
    </TableToolbar.Root>
  )
}

PlanMenuTileToolbar.propTypes = {
  search: PropTypes.string,
  setSearch: PropTypes.func,
  setShowInactive: PropTypes.func,
  showInactive: PropTypes.bool,
  hideToggle: PropTypes.bool,
  selectedItems: PropTypes.array,
  setSelectedItems: PropTypes.func
}

export default PlanMenuTileToolbar
